export function run()
{
    document.querySelectorAll('[data-setter]').forEach(function(element) {
        const elementAttr = element.getAttribute('data-setter');
        element.addEventListener('click', function(e) {
            if(elementAttr) {
                let [attribute, value] = elementAttr.split(',');
                let target = document.querySelector('['+attribute+']');
                if(target) {
                    const actualValue = target.getAttribute(attribute);
                    if(value === actualValue) {
                        target.setAttribute(attribute, '');
                    } else {
                        target.setAttribute(attribute, value);
                    }
                }
            }
        });
    });
}
